// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
/* eslint-disable camelcase */

import { createAsyncAction } from 'typesafe-actions';

import { LabInformation } from '../../types/Model';

export interface ChallengeInformationRequestPayload {
  id: number;
  condition: string;
  workshopId?: number;
  iltCourseId?: number;
  preventLoading?: boolean;
}
export interface ChallengeInformationSuccessPayload {
  challengeInformation: LabInformation;
}

export interface ChallengeInformationFailPayload {
  error: Error;
}

export const getChallengeInformationActions = createAsyncAction(
  'elearning/GET_CHALLENGE_INFORMATION',
  'elearning/GET_CHALLENGE_INFORMATION_SUCCESS',
  'elearning/GET_CHALLENGE_INFORMATION_FAIL'
)<ChallengeInformationRequestPayload, ChallengeInformationSuccessPayload, ChallengeInformationFailPayload>();
